const TestingSuiteActionTypes = {
    FETCH_TEST_USER_START: "FETCH_TEST_USER_START",
    FETCH_TEST_USER_SUCCESS: "FETCH_TEST_USER_SUCCESS",
    FETCH_TEST_USER_FAILURE: "FETCH_TEST_USER_FAILURE",
    CREATE_TEST_USER_START: "CREATE_TEST_USER_START",
    CREATE_TEST_USER_SUCCESS: "CREATE_TEST_USER_SUCCESS",
    CREATE_TEST_USER_FAILURE: "CREATE_TEST_USER_FAILURE",
};

export default TestingSuiteActionTypes